import { TherapistDetailSchema, type TherapistDetail } from '@hedepy/common/schemas/modules/therapist/therapist'

import { useApis } from '@/legacy-src/contexts/api-context'

import { useSwrQuery, type SwrQueryOptions } from '@/src/domains/swr/hooks/useSwrQuery'

export const getGetTherapistDataSWRKey = (therapistUserId: number) => [therapistUserId, 'therapist', 'GET'] as const

export const useGetTherapistData = <Config extends SwrQueryOptions<TherapistDetail> | undefined>(
  therapistUserId: number,
  options?: Config,
) => {
  const { api } = useApis()

  return useSwrQuery(
    getGetTherapistDataSWRKey(therapistUserId),
    async () => {
      const { data } = await api.getTherapistData(therapistUserId)

      return TherapistDetailSchema.parse(data)
    },
    options,
  )
}
